import React from "react";
import { Icon } from "../core/Icon.jsx";

export function Breadcrumb({ trail = [], onNavigate, style = {} }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0, ...style }}>
      {trail.map((t, i) => {
        const last = i === trail.length - 1;
        return (
          <React.Fragment key={t + i}>
            {i > 0 ? <Icon name="chevron-right" size={14} style={{ color: "var(--fg-10)" }} /> : null}
            <span onClick={last ? undefined : () => onNavigate && onNavigate(t, i)} style={{
              fontSize: "var(--fs-13)", color: last ? "var(--fg-1)" : "var(--fg-7)",
              fontWeight: last ? "var(--fw-semibold)" : "var(--fw-regular)",
              cursor: last ? "default" : "pointer", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", minWidth: last ? 0 : undefined,
            }}>{t}</span>
          </React.Fragment>
        );
      })}
    </div>
  );
}
